import * as flexsearch from "flexsearch";

import { IWorkspaceResourcePresentationTemplate, WorkspaceResourceType } from "common/interfaces";
import { search as searchApi } from "apis-v2/callables";

import { IPresentationsPanePresentation, BasePresentationsPaneController, BasePresentationsPaneControllerState } from "./BasePresentationsPaneController";

export type IPresentationTemplatesPanePresentation = IPresentationsPanePresentation;

export type PresentationTemplatesPaneControllerState = BasePresentationsPaneControllerState<IWorkspaceResourcePresentationTemplate>;

class PresentationTemplatesPaneController extends BasePresentationsPaneController<IWorkspaceResourcePresentationTemplate> {
    protected get _resourceTypes(): WorkspaceResourceType[] {
        return [WorkspaceResourceType.PRESENTATION_TEMPLATE];
    }

    protected async _fetchSearchIndex({ locale, workspaceId }: { locale: string, workspaceId: string }): Promise<{ indexConfig: flexsearch.DocumentOptions<any>, indexFileReadUrl: string }> {
        return searchApi.getPresentationTemplatesSearchIndex({ workspaceId, locale });
    }
}

const presentationTemplatesPaneController = new PresentationTemplatesPaneController();
export default presentationTemplatesPaneController;
